// extracted by mini-css-extract-plugin
export var gif = "_md-0";